import {
  isProvisionalStarStatus,
  PROVISIONAL_STAR,
  PROVISIONAL_STAR_LEGEND,
} from '@/lib/lab/labDisplay';

export function LabProvisionalStar({
  code,
}: {
  code: string | null | undefined;
}) {
  if (!isProvisionalStarStatus(code)) return null;
  return (
    <span className="lab-provisional-star" title="midlertidigt svar">
      {PROVISIONAL_STAR}
    </span>
  );
}

export function LabProvisionalStarLegend({
  codes,
}: {
  codes: ReadonlyArray<string | null | undefined>;
}) {
  if (!codes.some(isProvisionalStarStatus)) return null;
  return (
    <div className="lab-legend lab-provisional-star-legend mt-s3">
      <span>{PROVISIONAL_STAR_LEGEND}</span>
    </div>
  );
}
